import { render, staticRenderFns } from "./TrafegoMonitoramento.vue?vue&type=template&id=406a0176&"
import script from "./TrafegoMonitoramento.vue?vue&type=script&lang=js&"
export * from "./TrafegoMonitoramento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports